






















































































import { Component, Mixins } from "vue-property-decorator";
import { WorkflowDestination } from "../../../domain/workflow/items";
import { WorkflowCommonMixin } from "../mixins";
import { DialogMixin } from "../../system/mixins";
import { default as CommentEditor, instanceOfICommentEditor } from "../editors/controls/CommentEditor.vue";
import { IReferenceCommentListTableCondition } from "../lists/tables/IReferenceCommentListTableCondition";
import { IWorkflowActionDialogCondition } from "./IWorkflowActionDialogCondition";

export interface IWorkflowActionResult {
  isConfirmed: boolean;
  selectedDestination: WorkflowDestination;
  nextMessage: string;
  backMessage: string;
}

@Component({
  components: {
    CommentEditor,
  }
})
export default class WorkflowActionDialog extends Mixins(DialogMixin, WorkflowCommonMixin) {
  data(): any {
    return {
      isConfirmed: false,
      isEdit: false,
      title: "",
      confirmMessage: "",
      referenceCondition: null,
      nextMessagePermitted: false,
      nextMessageTitle: "",
      nextMessage: "",
      backMessagePermitted: false,
      backMessageTitle: "",
      backMessage: "",
      destinations: [],
      selectedDestination: null,
    };
  }
  isConfirmed: boolean;
  isEdit: boolean;
  title: string;
  confirmMessage: string;
  referenceCondition: IReferenceCommentListTableCondition;
  nextMessagePermitted: boolean;
  nextMessageTitle: string;
  nextMessage: string;

  backMessagePermitted: boolean;
  backMessageTitle: string;
  backMessage: string;

  destinations: WorkflowDestination[];
  selectedDestination: WorkflowDestination;

  get dialogWidth(): string {
    return this.isMessageEdit
      ? "96vw"
      : "700px";
  }

  get dialogTop(): string {
    return this.isMessageEdit
      ? "2vh"
      : "15vh";
  }

  get editorStyle(): any {
    return this.isMessageEdit
      ? {
        height: "calc(85vh - 250px - " + (this.destinations.length * 24) + "px)",
        maxHeight: "calc(95vh - 220px)",
      }
      : {
        height: "10em",
      };
  }

  get isSendBack(): boolean {
    return this.destinations.length > 0;
  }

  get isNextMessagePermitted(): boolean {
    return !this.isSendBack && this.nextMessagePermitted;
  }

  get isBackMessagePermitted(): boolean {
    return this.isSendBack && this.backMessagePermitted;
  }

  get isMessageEdit(): boolean {
    return this.isNextMessagePermitted || this.isBackMessagePermitted;
  }

  async show(condition: IWorkflowActionDialogCondition): Promise<IWorkflowActionResult> {
    return this.showModal(async () => {

      this.isConfirmed = false;
      this.isEdit = true;
      this.title = condition.actionPermission.buttonName;
      this.confirmMessage = condition.actionPermission.confirmMessage;
      this.referenceCondition = condition.reference;
      this.destinations = condition.actionPermission.destinations;
      this.selectedDestination = this.destinations[this.destinations.length - 1];

      this.nextMessagePermitted = condition.nextMessagePermission ? condition.nextMessagePermission.isPermitted : false;
      this.nextMessageTitle = condition.nextMessagePermission ? condition.nextMessagePermission.buttonName : "伝達事項";
      this.nextMessage = condition.nextMessage;

      this.backMessagePermitted = condition.backMessagePermission ? condition.backMessagePermission.isPermitted : false;
      this.backMessageTitle = condition.backMessagePermission ? condition.backMessagePermission.buttonName : "差戻しコメント";
      this.backMessage = "";

      // 差戻先がない+伝達事項の表示が非表示+確認メッセージが空のとき、ダイアログ表示せず終了
      if (!this.isSendBack && !this.nextMessagePermitted && !this.confirmMessage) {
        this.confirm();
        return {
          isConfirmed: this.isConfirmed,
          selectedDestination: this.selectedDestination,
          nextMessage: this.nextMessage,
          backMessage: this.backMessage,
        };
      }

      if (this.isMessageEdit) {
        await this.$nextTick();
        if (instanceOfICommentEditor(this.$refs.commentEditor)) {
          const textLength = (this.isNextMessagePermitted && this.nextMessage)
            ? this.nextMessage.length
            : 0;
          this.$refs.commentEditor.focus();
          this.$refs.commentEditor.setSelectionRange(textLength, textLength);
        }
      }
      await this.waitHidden();
      this.referenceCondition = null;
      return {
        isConfirmed: this.isConfirmed,
        selectedDestination: this.selectedDestination,
        nextMessage: this.nextMessage,
        backMessage: this.backMessage,
      };
    });
  }

  async confirm(): Promise<void> {
    this.isConfirmed = true;
    this.isVisible = false;
  }

  close(): void {
    this.isVisible = false;
  }

  get editingCommentLabel(): string {
    return this.isNextMessagePermitted
      ? this.nextMessageTitle
      : "";
  }
}
